import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const NcDlService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}/ncdl`;

  service.getNcDlOrdersBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/search${queryString}`, {
      headers,
    });
  };

  service.resendTdc = (transactionId, lineItemId, force = true) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const resendTdcRequest = {
      transactionId,
      lineItemId,
      force,
    };

    return axios.post(
      `${BASE_URL}/resendTdc`,
      resendTdcRequest,
      {
        headers,
      }
    );
  };

  return service;
})();

export default NcDlService;
